import React from "react";
import { Box, Typography } from "convertupleads-theme";
import BasicSelectDefault from "./BasicSelectDefault";
import BasicSelectUnfoldIcon from "./BasicSelectUnfoldIcon";
import BasicSelectStatusIcon from "./BasicSelectStatusIcon";
import BasicSelectWithAvatar from "./BasicSelectWithAvatar";
import BasicSelectWithTag from "./BasicSelectWithTag";
import BasicSelectSmall from "./BasicSelectSmall";
import BasicSelectError from "./BasicSelectError";

const BasicSelect = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Select
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          Menus are positioned under their emitting elements, unless they are
          close to the bottom of the viewport.
        </Typography>
      </Box>
      <BasicSelectDefault />
      <BasicSelectSmall />
      <BasicSelectError />
      <BasicSelectUnfoldIcon />
      <BasicSelectStatusIcon />
      <BasicSelectWithAvatar />
      <BasicSelectWithTag />
    </>
  );
};

export default BasicSelect;
